<template>
  <div v-if="showing" class="overlay" @click="close()">
    <div class="alert" @click="close()">
      {{ mensaje }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showing: false,
      mensaje: "--",
      logout: false
    };
  },
  mounted() {
    let vm = this;
    this.$eventBus.$on("error-comunicacion-servidor", function(mensaje) {
      console.log("Error: " + mensaje);
      vm.mensaje = mensaje;
      vm.showing = true;
      setTimeout(vm.close, 5000);
    });

    this.$eventBus.$on("sesion-caducada", function() {
      let mensaje = "Sesion caducada";
      console.log("Error: " + mensaje);
      vm.mensaje = mensaje;
      vm.showing = true;
      vm.logout = true;
      setTimeout(vm.close, 3000);
    });
  },
  methods: {
    close() {
      this.showing = false;
      if (this.logout) {
        this.$store.dispatch("logout");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  background-color: red;
  color: white;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  padding: 2rem;
  border: 1px solid white;
}

.overlay {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
}
</style>
